import { TrashIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { queryClient } from "@/libs/react-query";
import { useTranslation } from "react-i18next";

import { useDeleteNavigationItem } from "../api/delete-navigation-item";

type DeleteNavigationitemDialogProps = {
  menuItemId: string;
};

function DeleteNavigationItemDialog(props: DeleteNavigationitemDialogProps) {
  const { t } = useTranslation();
  const { menuItemId } = props;
  const { mutateAsync: deleteNavigationItem, isPending } =
    useDeleteNavigationItem();

  const handleDeleteNavigationItem = async () => {
    await deleteNavigationItem({ menuItemId });
    await queryClient.refetchQueries({
      queryKey: ["navigation"],
    });
    //TODO: handle server error
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size="sm" variant="link" className="ml-auto" type="button">
          <TrashIcon className="mr-1.5 size-4" />
          {t("navItem.remove")}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("confirmDialog.title")}</DialogTitle>
          <DialogDescription>
            {t("confirmDialog.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" disabled={isPending}>
              {t("confirmDialog.cancel")}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button onClick={handleDeleteNavigationItem} disabled={isPending}>
              {t("confirmDialog.confirm")}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { DeleteNavigationItemDialog };
